import { Group, ScrollArea, Stack, Switch, Table, Text } from "@mantine/core";
import { useState } from "react";

function ImportProtoListEmbedded({ importData }) {
  const [showAllAttributes, setShowAllAttributes] = useState(false);

  const displayColumns = showAllAttributes
    ? importData.columns
    : importData.columns.slice(0, 4);

  const keys = importData.columns?.map((p) => p.key);
  if (!keys) {
    return <div>No keys!</div>;
  }

  const itemsToDisplay = importData.productVariantProtos;

  return (
    <Stack>
      <Group mb="sm" justify="space-between">
        <Switch
          checked={showAllAttributes}
          label="Show all attributes"
          onChange={() => setShowAllAttributes((prev) => !prev)}
        />
      </Group>
      <ScrollArea type="always" h="80dvh" w="100%">
        <Table stickyHeader fz="xs" withTableBorder>
          <Table.Thead>
            <Table.Tr>
              <Table.Th w={30}>Row</Table.Th>
              <Table.Th w={40} style={{ borderRight: "1px solid #ccc" }}>
                Attributes
              </Table.Th>
              {displayColumns.map((column) => (
                <Table.Th key={column.key} style={{ whiteSpace: "nowrap" }}>
                  {column.key}
                </Table.Th>
              ))}
            </Table.Tr>
          </Table.Thead>

          <Table.Tbody>
            {itemsToDisplay.map((productVariantProto, index) => (
              <Table.Tr key={productVariantProto.id}>
                <Table.Td ta="right">{index + 1}</Table.Td>
                <Table.Th ta="right" style={{ borderRight: "1px solid #ccc" }}>
                  {keys.length}
                </Table.Th>
                {displayColumns.map(({ key }) => (
                  <Table.Td
                    style={{ whiteSpace: "nowrap" }}
                    key={`${productVariantProto.id}-${key}`}
                  >
                    {productVariantProto.fieldValues[key]}
                  </Table.Td>
                ))}
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </ScrollArea>
    </Stack>
  );
}

export default ImportProtoListEmbedded;
